import { render, staticRenderFns } from "./ApiTest.vue?vue&type=template&id=d5542bea&scoped=true"
import script from "./ApiTest.vue?vue&type=script&lang=js"
export * from "./ApiTest.vue?vue&type=script&lang=js"
import style0 from "./ApiTest.vue?vue&type=style&index=0&id=d5542bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5542bea",
  null
  
)

export default component.exports